import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import BlogService from "../../Service/BlogService";
import { Navigation, Pagination } from "swiper/modules";
import 'swiper/css/bundle';
import { Navigate } from "react-router-dom";

const TrainersSlider = ({ formateurs, token }) => {
    const handleDeleteClick = async (id) => {
        try {
            await BlogService.deleteFormateurs(id);
            window.location.reload();
        } catch (error) {
            console.error("Error deleting article:", error);
        }
    };

    // Check if the formateurs array is empty
    if (!formateurs || formateurs.length === 0) {
        return (
            <div className="no-trainers">
                <p style={{ textAlign: "center", fontStyle: "italic", color: "#666" }}>
                    Les formateurs seront prochainement renseignés.
                </p>
            </div>
        );
    }

    return (
        <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1} // Default for mobile
            navigation // Adds navigation buttons
            pagination={{ clickable: true }} // Dots for pagination
            breakpoints={{
                768: { slidesPerView: 2 }, // Show 2 trainers for tablets
                1024: { slidesPerView: 4 }, // Show 4 trainers for desktop
            }}
        >
            {formateurs.map((trainer, index) => (
                <SwiperSlide key={index}>
                    <div className="trainer">
                        <div className="trainer-info">
                            <h3 style={{ color: "rgba(255,0,0,1)", fontWeight: "700" }}>{trainer.prenom}</h3>
                            <p style={{ fontWeight: "500" }}>{trainer.role}</p>
                            <p style={{ fontSize: "12px" }}>{trainer.type}</p>
                            <blockquote style={{ fontStyle: "italic", fontSize: "12px" }}>
                                “ {trainer.description} “
                            </blockquote>
                        </div>
                        {token === "" && (
                            <button
                                className="inscription-button delete_button"
                                onClick={() => handleDeleteClick(trainer.id)}
                                style={{ marginLeft: "10px", backgroundColor: "red", color: "white" }}
                            >
                                Supprimer
                            </button>
                        )}
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default TrainersSlider;